'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMessageToThreadHistory = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _ifThen = require('transmute/ifThen');

var _ifThen2 = _interopRequireDefault(_ifThen);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _pubNubMessageKeyInvariant = require('conversations-schema/invariants/pubNubMessageKeyInvariant');

var _pubNubMessageRecordInvariant = require('conversations-schema/invariants/pubNubMessageRecordInvariant');

var _threadHistoryInvariant = require('conversations-schema/invariants/threadHistoryInvariant');

var _setMessage = require('conversations-schema/thread-history/operators/setMessage');

var _sortMessages = require('conversations-schema/thread-history/operators/sortMessages');

var _hasInitialMessagesToPublish = require('conversations-schema/thread-history/operators/hasInitialMessagesToPublish');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add a message to ThreadHistory and conditionally sort if the message is not
 * presentational.  Sorting can be skipped otherwise because the projection of
 * the history will not change.
 *
 * @param {PubNubMessageKey} messageKey
 * @param {PubNubMessageRecord} message
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */
var addMessageToThreadHistory = exports.addMessageToThreadHistory = (0, _curry2.default)(function (messageKey, message, threadHistory) {
  (0, _pubNubMessageKeyInvariant.pubNubMessageKeyInvariant)(messageKey);
  (0, _pubNubMessageRecordInvariant.pubNubMessageRecordInvariant)(message);
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  return (0, _pipe2.default)((0, _setMessage.setMessage)(messageKey, message), (0, _ifThen2.default)(function () {
    return !(0, _hasInitialMessagesToPublish.hasInitialMessagesToPublish)(threadHistory) && (0, _messageTypeComparators.isPresentationalMessage)(message);
  }, _sortMessages.sortMessages))(threadHistory);
});


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/operators/addMessageToThreadHistory.js
// module id = 333
// module chunks = 2 3